import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

/**
 * The selected tab of a record form, kept in `?tab=` so links, reloads and Back keep it.
 * Unknown values fall back to the first tab.
 */
export function useTabParam(ids: readonly string[]): [string, (id: string) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get('tab');
  const fallback = ids[0] ?? 'main';
  const tab = requested && ids.includes(requested) ? requested : fallback;
  const setTab = useCallback(
    (id: string) => {
      setSearchParams(
        (previous) => {
          const next = new URLSearchParams(previous);
          if (id === fallback) next.delete('tab');
          else next.set('tab', id);
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams, fallback],
  );
  return [tab, setTab];
}
